module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('b-field', [_c('b-input', {
    attrs: {
      "placeholder": "Email",
      "type": "email"
    }
  })], 1), _vm._v(" "), _c('b-field', [_c('b-input', {
    attrs: {
      "placeholder": "Number",
      "type": "number",
      "min": "10",
      "max": "20"
    }
  })], 1), _vm._v(" "), _c('b-field', [_c('b-input', {
    attrs: {
      "placeholder": "User handle (custom validation for only lowercase)",
      "type": "text",
      "required": "",
      "validation-message": "Only lowercase is allowed",
      "pattern": "[a-z]*"
    }
  })], 1), _vm._v(" "), _c('b-field', [_c('b-input', {
    attrs: {
      "placeholder": "URL",
      "type": "url"
    }
  })], 1), _vm._v(" "), _c('b-field', [_c('b-input', {
    attrs: {
      "type": "textarea",
      "minlength": "10",
      "maxlength": "100",
      "placeholder": "Maxlength automatically counts characters"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2674094b"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./docs/pages/components/input/examples/ExValidation.vue
// module id = 1101
// module chunks = 13 214